import { render, staticRenderFns } from "./GradientScroll.vue?vue&type=template&id=6a298846&scoped=true&"
import script from "./GradientScroll.vue?vue&type=script&lang=js&"
export * from "./GradientScroll.vue?vue&type=script&lang=js&"
import style0 from "./GradientScroll.vue?vue&type=style&index=0&id=6a298846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a298846",
  null
  
)

export default component.exports